import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	chatBotName: {
		fontSize: "20px"
	},
	unknown: {
		color: colors.gray[400]
	}
})

export default useStyles
